module.exports = __webpack_public_path__ + "media/images/swifticons/datawork-b29a11f1b0ed433d2fff330fc843ea93.svg";